





































































































































































































































































































































































































































import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import { Vue, Component, Prop } from 'vue-property-decorator';
import { Agreement } from '../types/Agreement';
import { BudgetLoanForecastForm } from '../types/BudgetLoanForecastForm';
import { cloneDeep, debounce, isNumber } from 'lodash';
import { FactEntry } from '../types/FactResponse';
import moment, { Moment } from 'moment';
import { ScheduleType } from '../types/ScheduleType';
import { Option } from '../types/Option';
import { formatNumber, parseSpacedDecimal } from '../utils';
import { AgreementForm } from '../types/AgreementForm';
import store from '@/services/store';
import { PlanEntry } from '../types/PlanResponse';
import { ScheduleRow } from '../types/ScheduleRow';

interface Column {
    key: string
    label: string
    rowSpan: number
    colSpan: number
}

interface HeaderData {
    mainNumberContract: string | null
    actualNumberContract: string | null
    actualAmount: number | null
    actualContractor: string | null
}

interface FactRequest {
    id: number | null
    idContract: number
    typeSchedule: ScheduleType
    sumPaymentFact: number | null
    dateFact: string
    code: string
    note: string | null
    userName: string | null
    updateDate: number | null
}

interface PaymentForm {
    id: number | null
    paymentType: ScheduleType | null
    amount: string | null
    date: string | null
    kbk: Option<string> | null
    note: string | null
}

interface EditDayCount {
    date: string
    daysCount: number
}

const defaultPaymentForm: PaymentForm = {
    id: null,
    paymentType: null,
    amount: null,
    date: null,
    kbk: null,
    note: null
}

const emptyScheduleRow: ScheduleRow = {
    rowNumber: 0,
    leftPrincipal: null,
    paymentDate: new Date().getTime(),
    kbkCode: null,
    inflowPlan: null,
    inflowFact: null,
    principalPlan: null,   
    principalFact: null,
    earlyRepayment: null,
    unusedSum: null,
    startDate: null,
    endDate: null,
    daysCount: null,
    baseSum: null,
    interestPlan: null,
    interestFact: null,
    copaymentPlan: null,
    copaymentFact: null,
    isEarlyRepayment: null,
    note: null,
    // Additinal data properties
    inflowFactData: null,
    principalFactData: null,
    earlyRepaymentData: null,
    unusedSumData: null,
    interestFactData: null,
    copaymentFactData: null
}


@Component
export default class Fact2ScheduleTab extends Vue {
    // #region Props
    @Prop({
        type: Boolean,
        required: true
    })
    public readonly isWriteAccess!: boolean

    @Prop({
        type: String,
        required: true
    })
    public readonly currentMode!: string

    
    @Prop({
        type: Object,
        required: true
    })
    public readonly currentForm!: AgreementForm
    
    // Only for header
    @Prop({
        type: Object,
        required: true
    })
    public readonly mainAgreementForm!: AgreementForm

    // Only for header
    @Prop({
        type: Object,
        required: true
    })
    public readonly actualAgreementForm!: AgreementForm
    // #endregion

    // #region Data
    paymentForm: PaymentForm = cloneDeep(defaultPaymentForm)
    
    scheduleRows: ScheduleRow[] = []
    tempScheduleRows: ScheduleRow[] = []

    headerData: HeaderData = {
        mainNumberContract: null,
        actualNumberContract: null,
        actualAmount: null,
        actualContractor: null
    }

    kbkOptions: Option<string>[] = []
    options243: Option<string>[] = []
    item243: Option<string> | null = null

    currentAgreement: Agreement | null = null
    mainAgreement: Agreement | null = null
    // private previousAgreement: Agreement | null = null
    allAgreements: Agreement[] | null = null

    planDates: Set<number> = new Set()
    forecastRows: ScheduleRow[] = []
    progress = 100
    kbkLoading = false
    showPaymentFormModal = false
    selectedPaymentFormMode: 'FORM' | '2-43' = 'FORM'
    showCommentModal = false

    isInterestDetailsVisible = false

    isForecastWarningMessageVisible = false

    daysEditMode = false

    readonly tableColumns: Column[] = [
        {
            key: "rowNumber",
            label: "№",
            rowSpan: 2,
            colSpan: 1
        },
        {
            key: "leftPrincipal",
            label: "Остаток основного долга на начало периода",
            rowSpan: 2,
            colSpan: 1
        },
        {
            key: "paymentDate",
            label: "Дата платежа",
            rowSpan: 1,
            colSpan: 2
        },
        {
            key: 'kbk',
            label: 'КБК',
            rowSpan: 2,
            colSpan: 1
        },
        {
            key: "inflowSum",
            label: "Cумма поступления",
            rowSpan: 1,
            colSpan: 2
        },
        {
            key: "principalSum",
            label: "Сумма погашения основного долга",
            rowSpan: 1,
            colSpan: 3
        },
        {
            key: "unusedSum",
            label: "Сумма неиспользованных средств",
            rowSpan: 2,
            colSpan: 1
        },
        {
            key: "interestData",
            label: "Данные для расчета вознаграждения",
            rowSpan: 1,
            colSpan: 4
        },
        {
            key: "interestSum",
            label: "Сумма начисленного вознаграждения",
            rowSpan: 1,
            colSpan: 2
        },
        {
            key: "copaymentSum",
            label: "Сумма сопутствующих платежей",
            rowSpan: 1,
            colSpan: 2
        },
        {
            key: "earlyRepaymentFlag",
            label: "Признак досрочного погашения осн. долга",
            rowSpan: 2,
            colSpan: 1
        },
        {
            key: "comment",
            label: "",
            rowSpan: 2,
            colSpan: 1
        },
        {
            key: "action",
            label: "",
            rowSpan: 2,
            colSpan: 1
        }
    ]

    readonly tableLowerColumns: Column[] = [
        // Под "Дата платежа" (paymentDate)
        {
            key: "paymentDate",
            label: "План",
            rowSpan: 1,
            colSpan: 1
        },
        {
            key: "paymentFactDate",
            label: "Факт",
            rowSpan: 1,
            colSpan: 1
        },
        // Под "Cумма поступления" (inflowSum)
        {
            key: "inflowPlan",
            label: "План",
            rowSpan: 1,
            colSpan: 1
        },
        {
            key: "inflowFact",
            label: "Факт",
            rowSpan: 1,
            colSpan: 1
        },
        // Под "Сумма погашения основного долга" (principalSum)
        {
            key: "principalPlan",
            label: "План",
            rowSpan: 1,
            colSpan: 1
        },
        {
            key: "principalFact",
            label: "Факт",
            rowSpan: 1,
            colSpan: 1
        },
        {
            key: "earlyRepayment",
            label: "Досрочное погашение",
            rowSpan: 1,
            colSpan: 1
        },
        // Под "Данные для расчета вознаграждения" (interestData)
        {
            key: "startDate",
            label: "Начало периода начисления",
            rowSpan: 1,
            colSpan: 1
        },
        {
            key: "endDate",
            label: "Окончание периода начисления",
            rowSpan: 1,
            colSpan: 1
        },
        {
            key: "daysCount",
            label: "Кол-во дней",
            rowSpan: 1,
            colSpan: 1
        },
        {
            key: "baseSum",
            label: "Базовая сумма для начисления вознаграждения",
            rowSpan: 1,
            colSpan: 1
        },
        // Под "Сумма начисленного вознаграждения" (interestSum)
        {
            key: "interestPlan",
            label: "План",
            rowSpan: 1,
            colSpan: 1
        },
        {
            key: "interestFact",
            label: "Факт",
            rowSpan: 1,
            colSpan: 1
        },
        // Под "Сумма сопутствующих платежей" (copaymentSum)
        {
            key: "copaymentPlan",
            label: "План",
            rowSpan: 1,
            colSpan: 1
        },
        {
            key: "copaymentFact",
            label: "Факт",
            rowSpan: 1,
            colSpan: 1
        }
    ]

    scheduleRowKeys: (keyof ScheduleRow)[] = [
        "rowNumber",
        "leftPrincipal",
        "paymentDate",
        "kbkCode",
        "inflowPlan",
        "inflowFact",
        "principalPlan",
        "principalFact",
        "earlyRepayment",
        "unusedSum",
        "startDate",
        "endDate",
        "daysCount",
        "baseSum",
        "interestPlan",
        "interestFact",
        "copaymentPlan",
        "copaymentFact",
        "isEarlyRepayment"
    ]
    // #endregion

    // #region Getters
    get userId(): string | null {
        return store.state.user.sub ?? null
    }
    // #endregion

    // #region LifeCycle
    async created() {
        if (this.currentForm.id == null) {
            return
        }

        this.allAgreements = await this.getAgreements(this.currentForm.id)
        this.currentAgreement = this.allAgreements.find(it => it.id === this.currentForm.id) ?? null
        this.mainAgreement = this.allAgreements.find(it => it.type === 0) ?? null

        this.assignHeaderData()

        await this.constructRows()

        await this.load243Options()
    }
    // #endregion

    // #region Methods
    getPeriodicDates(firstDate: Moment, returnDate: Date, frequency: string): Map<string, number> {
        const stepMap: Record<string, number> = {
            "001": 12, // yearly
            "002": 3,  // quarterly
            "003": 6,  // half-yearly
            "004": 1   // monthly
        };

        const monthsStep: number = stepMap[frequency] || 12

        const start = moment(firstDate)
        const end = moment(returnDate)

        const result: Map<string, number> = new Map()
        const current = start.clone()

        while (current.isSameOrBefore(end)) {
            result.set(current.format("YYYY-MM-DD"), 0)
            current.add(monthsStep, 'months')
        }

        return result
    }

    emitSetFact(rows: ScheduleRow[]) {
        this.$emit('setFact', {
            rows: cloneDeep(rows),
            mainAgreementNumber: this.headerData.mainNumberContract || '',
            actualAgreementNumber: this.headerData.actualNumberContract || ''
        })
    }

    toggleDaysEditMode(isEnabled: boolean | null = null) {
        if (isEnabled === null) {
            this.daysEditMode = !this.daysEditMode
        } else {
            this.daysEditMode = isEnabled
        }
        
        if (this.daysEditMode) {
            this.tempScheduleRows = cloneDeep(this.scheduleRows)
        } else {
            this.scheduleRows = this.tempScheduleRows
        }
    }

    async onCorrectedDaysSaveEdited() {
        const edited: EditDayCount[] = this.scheduleRows
            .filter(row => row.daysCount != null)
            .map(row => {
                const mapped: EditDayCount = {
                    date: this.toYYYYMMDDformat(row.paymentDate),
                    daysCount: row.daysCount!
                }
                return mapped
            })
        const initial: EditDayCount[] = this.tempScheduleRows
            .filter(row => row.daysCount != null)
            .map(row => {
                const mapped: EditDayCount = {
                    date: this.toYYYYMMDDformat(row.paymentDate),
                    daysCount: row.daysCount!
                }
                return mapped
            })

        const payload: EditDayCount[] = []
        initial.forEach(initialItem => {
            const correspondingEditedItem = edited.find(editedItem => editedItem.date === initialItem.date)
            if (correspondingEditedItem && correspondingEditedItem?.daysCount !== initialItem.daysCount) {
                payload.push({
                    date: correspondingEditedItem.date,
                    daysCount: correspondingEditedItem.daysCount
                })
            }
        })
        if (payload.length > 0) {
            await this.getForecastScheduleWithDayCountCorrection(payload)
        }
        this.tempScheduleRows = []
        this.daysEditMode = false
    }

    async getForecastScheduleWithDayCountCorrection(daysCountCorrections: EditDayCount[]) {
        this.progress = 30
        try {
            const response = await fetch(`/api/budget-loan-schedule/payment-schedule-forecast/get-data-with-correct/${this.currentForm.id}`, {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(daysCountCorrections)
            })
            this.progress = 80
            this.makeToast('Редактирование применено', 'Сообщение', 'success')

            await this.constructRows()

            this.$emit('reloadFact')
        } catch (error) {
            this.makeToast('Не удалось загрузить прогнозные данные', 'Ошибка', 'danger')
        } finally {
            this.progress = 100
        }
    }

    clearNote() {
        this.paymentForm.note = null
    }

    getColumnVisibility(columnKey: string): boolean {
        const interestDetailsColumns = ['startDate', 'endDate', 'daysCount', 'baseSum', 'interestData']
        return (interestDetailsColumns.includes(columnKey) && this.isInterestDetailsVisible) || !interestDetailsColumns.includes(columnKey)
    }
    
    toggleIsInteresetDetailsVisible() {
        this.isInterestDetailsVisible = !this.isInterestDetailsVisible
    }

    async load243Options() {
        if (!this.mainAgreement?.id) {
            return
        }

        const response = await fetch(`api/budget-loan-schedule/payment-fact-inflow/get-243-data-v02/${this.mainAgreement.id}`)
        if (response.ok) {
            const data: unknown[] = await response.json()
            const options: Option<string>[] = data.map((it: any) => {
                return {
                    value: it.specific,
                    label: it.description,
                    additionalData: it
                }
            })
            this.options243 = options
        }
    }

    on243Select(option: Option<string> | null) {
        if (option == null) {
            return
        }

        const kbk = this.kbkOptions.find(it => it.value == option.value)
        if (kbk) {
            const data = option.additionalData
            const form: PaymentForm = {
                id: null,
                date: this.toYYYYMMDDformat(data.paymentdate),
                amount: data.amount,
                note: data.description,
                kbk: kbk,
                paymentType: null
            }
            this.paymentForm = form
            this.onKbkSelect(kbk)
        } else {
            this.makeToast('Данный платеж не являеется доступным для данного договора', 'Сообщение', 'danger')
        }
    }

    async generateNewForecastSchedule() {
        this.progress = 50
        const response = await fetch(`/api/budget-loan-schedule/payment-schedule-forecast/generate/${this.currentForm.id}`, {
            method: 'POST'
        })
        if (!response.ok) {
            this.makeToast('Не удалось сгенерировать график', 'Ошибка', 'danger')
            return
        }
        this.makeToast('Сгенерировано', 'Сообщение', 'success')
        this.isForecastWarningMessageVisible = false
        this.reloadTable()
    }

    openSaveModal() {
        this.paymentForm = { ...defaultPaymentForm }
        this.item243 = null
        this.toggleFormModal(true)
    }

    async constructRows() {
        this.progress = 25
        const planRows = await this.getPlanRows()
        this.planDates = new Set(planRows.filter(it => it.paymentDate).map(it => it.paymentDate))
        this.progress = 50
        const forecastRows = await this.getForecastRows()
        this.forecastRows = cloneDeep(forecastRows)
        this.progress = 75
        const factRows = await this.getFactRows()
        this.progress = 90
        const finalScheduleRows = this.mergeRows(planRows, forecastRows, factRows)
        this.scheduleRows = finalScheduleRows
        this.emitSetFact(finalScheduleRows)
        this.progress = 100
    }

    async validateThenSavePaymentForm() {
        if (this.validatePaymentForm()) {
            await this.saveOrUpdatePaymentForm()
        }
    }

    validatePaymentForm() {
        if (!this.paymentForm.date) {
            this.makeToast('Не введена дата', 'Ошибка', 'danger')
            return
        }

        // TODO: revisit validations

        // Платежи должны быть в рамках действия договора
        // const latest = (new Date(this.latestEndDate)).getTime()
        // const earliest = (new Date(this.earliestStartDate)).getTime()
        // const checked = (new Date(this.paymentForm.date)).getTime()

        // this.toDateMilliseconds(this.latestEndDate)
        // this.toDateMilliseconds(this.earliestStartDate)
        // this.toDateMilliseconds(this.paymentForm.date)

        // if (checked < earliest) {
        //     this.makeToast('Дата платежа должна быть позже даты подписания', 'Ошибка', 'danger')
        //     return false
        // } else if (checked > latest) {
        //     this.makeToast('Дата платежа должна быть раньше даты возврата', 'Ошибка', 'danger')
        //     return false
        // }

        // Первый платеж должен быть поступлением
        if (this.paymentForm.paymentType !== ScheduleType.INFLOW) {
            // TODO: const firstFound = this.scheduleRows.find(it => this.hasFact(it) && it.typeSchedule === ScheduleType.INFLOW)
            // if (!firstFound) {
            //     this.makeToast('Необходимо ввести фактическую сумму поступлений', 'Ошибка', 'danger')                    
            //     return false
            // }

            // const firstIncomeDate = (new Date(firstFound.datePayment)).getTime()
            // if (firstIncomeDate > checked) {
            //     this.makeToast('Погашение не может быть раньше Поступлений', 'Ошибка', 'danger')                    
            //     return false
            // }
        }

        return true
    }

    onModalModeChange() {
        this.paymentForm = {...defaultPaymentForm}
        this.item243 = null
    }

    onKbkSelect(option: Option<string> | null) {
        if (option == null) {
            this.paymentForm = { ...this.paymentForm, paymentType: null }
            return
        }

        const data = option.additionalData

        let type: ScheduleType | null = null
        if ((data.kat === 7 || data.kat === 8) && data.cls === 1 && data.pcl === 2) {
            type = 1
        } else if ((data.kat === 5 || data.kat === 6) && data.cls === 1 && data.pcl === 1) {
            type = 2
        } else if (data.kat === 2 && data.cls === 1 && data.pcl === 7) {
            type = 3
        } else if ((data.kat === 5 || data.kat === 6) && data.cls === 1 && data.pcl === 2) {
            type = 8
        } else if (data.kat === 2 && data.cls === 4 && data.pcl === 1) {
            type = 5
        }

        this.paymentForm = { ...this.paymentForm, paymentType: type }
    }

    displayTypeName(typeNumber: ScheduleType | null) {
        switch (typeNumber) {
            case 1:
                return 'Поступления кредитов из вышестоящего бюджета'
            case 2:
                return 'Погашения бюджетных кредитов'
            case 3:
                return 'Выплаты по вознаграждениям'
            case 4:
                return 'Возврат бюджетных кредитов'
            case 5:
                return 'Сопутствующие платежи (штраф, пеня)'
            default:
                return ''
        }
    }

    async onPaymentDateChange(date: string | null) {
        await this.loadKbkOptions(date)
    }

    createOnPaymentDateChangeDebounced() {
        const that = this
        const temp = debounce(async function (date: string | null) {
            await that.onPaymentDateChange(date)
        }, 300)
        return temp
    }

    onPaymentDateChangeDebounced = this.createOnPaymentDateChangeDebounced()

    async confirmDeletion(row: ScheduleRow) {
        const id = this.getAnyFactId(row)
        if (id == null) {
            return
        }

        this.$bvModal.msgBoxConfirm(
            'Удалить выбранный факт?',
            {
                title: 'Подтверждение',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'Удалить',
                cancelTitle: 'Отмена',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(confirmed => {
                if (confirmed) {
                    this.deleteFact(id)
                }
            })
            .catch(error => {
                this.makeToast('Не удалось удалить факт', 'Ошибка удаления', 'danger')
                console.error(error.toString())
            })
    }

    async deleteFact(id: number) {
        const response = await fetch(`api/budget-loan-schedule/payment-fact-inflow/${id}`, {
            method: 'DELETE'
        })

        if (!response.ok) {
            let text = 'Ошибка при удалений'
            const errorResponse = await response.json()
            const message = errorResponse?.args[0]?.value[0]
            if (message) {
                text = message
            }
            this.makeToast(text, 'Ошибка', 'danger')
            return
        }
        this.makeToast('Успешно удалено', 'Сообщение', 'success')
        this.isForecastWarningMessageVisible = true
        await this.reloadTable()
    }

    async reloadTable() {
        this.toggleFormModal(false)
        this.toggleCommentModal(false)
        this.paymentForm = {...defaultPaymentForm}
        await this.constructRows()
        // TODO: Remove after removing forecastTab
        this.$emit('reloadForecast')
        this.$emit('reloadFact')
    }

    async openEditModal(row: ScheduleRow, isOnlyComment: boolean) {
        const id = this.getAnyFactId(row)
        if (id == null) {
            this.makeToast('Отсутсвует ID', 'Ошибка', 'danger')
            return
        }
        const paymentType = this.getAnyFactType(row)
        if (paymentType == null) {
            this.makeToast('Не вычеслен тип факта', 'Ошибка', 'danger')
            return
        }

        this.paymentForm = { ...defaultPaymentForm }

        const formattedPaymentDate = this.toYYYYMMDDformat(row.paymentDate)
        await this.loadKbkOptions(formattedPaymentDate)
        const kbkOption = cloneDeep(this.kbkOptions.find(it => it.value === row.kbkCode) ?? null)
        const amount = this.getAnyFactSum(row)

        const form: PaymentForm = {
            id: id,
            kbk: kbkOption,
            paymentType: paymentType,
            date: formattedPaymentDate,
            amount: amount?.toString() ?? null,
            note: row.note
        }

        this.paymentForm = form
    
        if (isOnlyComment) {
            this.toggleCommentModal(true)
        } else {
            this.toggleFormModal(true)
        }
    }

    async loadKbkOptions(date: string | number | null) {
        this.kbkLoading = true
        try {
            if (this.currentAgreement?.budgetLevel != null && date) {
                const budgetLevelId = this.currentAgreement?.budgetLevel
                const formattedDate: string = isNumber(date) ? this.toYYYYMMDDformat(date) : date
                const options = await this.fetchKbkOptions(budgetLevelId, formattedDate)
                const isCurrentKbkPresent = Boolean(options.find(it => it.value === this.paymentForm.kbk?.value))
                if (!isCurrentKbkPresent) {
                    this.paymentForm.kbk = null
                }
                this.kbkOptions = options
            } else {
                this.paymentForm.kbk = null
                this.kbkOptions = []
            }
        } catch (error) {
            console.error(error)
        } finally {
            this.kbkLoading = false
        }
    }

    async fetchKbkOptions(budgetLevelId: number, formattedDate: string): Promise<Option<string>[]> {
        const searchParams = new URLSearchParams()
        searchParams.set('budget-level-id', budgetLevelId.toString())
        searchParams.set('date', formattedDate)
        const response = await fetch(`api/dict/dict_ebk_doh/loan-payment?${searchParams}`)
        if (!response.ok) {
            this.makeToast('Не удалось загрузить опции КБК', 'Ошибка', 'danger')
            return []
        }
        const data = await response.json()
        const kbkList: unknown[] = data.items ? data.items : data

        const options: Option<string>[] = kbkList.map((it: any) => {
            const label = `${it.full_code} - ${it.name_ru}`
            return {
                value: it.full_code,
                label: label,
                additionalData: it
            }
        })

        return options
    }

    getAnyFactId(row: ScheduleRow): number | null {
        let id: number | null = null
        const factDataKeys = ['inflowFactData', 'principalFactData', 'earlyRepaymentData', 'unusedSumData', 'interestFactData', 'copaymentFactData'] as const
        for (const key of factDataKeys) {
            id = row[key]?.id ?? id
        }
        return id
    }

    getAnyFactType(row: ScheduleRow): ScheduleType | null {
        if (row.inflowFact) {
            return ScheduleType.INFLOW
        }
        if (row.principalFact) {
            return ScheduleType.PRINCIPAL_REPAYMENT
        }
        if (row.earlyRepayment) {
            return ScheduleType.PAYMENT_UNUSED
        }
        if (row.unusedSum) {
            return ScheduleType.PAYMENT_UNUSED
        }
        if (row.interestFact) {
            return ScheduleType.PAYMENT_INTEREST
        }
        if (row.copaymentFact) {
            return ScheduleType.PAYMENT_COPAYMENT
        }
        return null
    }

    getAnyFactSum(row: ScheduleRow): number | null {
        const factKeys = ['inflowFact', 'principalFact', 'earlyRepayment', 'unusedSum', 'interestFact', 'copaymentFact'] as const
        for (const key of factKeys) {
            if (row[key]) {
                return row[key]
            }
        }
        return null
    }

    toggleFormModal(isOn: boolean | null = null) {
        if (isOn === null) {
            this.showPaymentFormModal = !this.showPaymentFormModal
        } else {
            this.showPaymentFormModal = isOn
        }
    }

    toggleCommentModal(isOn: boolean | null = null) {
        if (isOn === null) {
            this.showCommentModal = !this.showCommentModal
        } else {
            this.showCommentModal = isOn
        }
    }
    
    get calculateTotalInterestPlan(): number {
        return this.forecastRows
            .map(it => it.interestPlan ?? 0)
            .reduce((acc, current) => acc + current, 0)
    }

    calculateTotal(scheduleData: ScheduleRow[], column: keyof ScheduleRow) {
        let total = 0
        scheduleData.forEach((item) => {
            const sum = item[column]
            if (sum && typeof sum === 'number') {
                total += (sum ?? 0)
            }
        })
        return total
    }

    copyData() {
        const text = `Платеж по договору ${this.currentForm.agreementNumber} от ${this.currentForm.signDate} по проекту ${this.currentForm.project?.label}`
        if (navigator.clipboard) {
            navigator.clipboard.writeText(text)
                .then(() => {
                    this.makeToast('Скопировано', 'Сообщение', 'success')
                })
                .catch(err => {
                    this.makeToast('Не удалось скопировать текст', 'Ошибка', 'danger')
                })
        } else {
            const textArea = document.createElement('textarea')
            textArea.value = text
            document.body.appendChild(textArea)
            textArea.select()

            try {
                const successful = document.execCommand('copy')
                if (successful) {
                    this.makeToast('Скопировано', 'Сообщение', 'success')
                } else {
                    throw new Error()
                }
            } catch (err) {
                this.makeToast('Не удалось скопировать текст', 'Ошибка', 'danger')
            } finally {
                document.body.removeChild(textArea)
            }
        }
    }

    openAdditionalsModal(action: string | null = null) {
        this.$emit('openAdditionalsModal', action)
    }

    goBack() {
        this.$emit('goBack')
    }

    async confirmEarlyRepaymentFlagToggle(row: ScheduleRow) {
        if (!this.isWriteAccess) {
            return
        }

        const title = !row.isEarlyRepayment ? 'Конвертировать в досрочное погашение?' : 'Обратить изменение?'
        const okTitle = !row.isEarlyRepayment ? 'конвертировать' : 'обратить'
        this.$bvModal.msgBoxConfirm(
            title,
            {
                title: 'Подтверждение',
                size: 'lg',
                buttonSize: 'sm',
                okVariant: 'primary',
                okTitle: okTitle,
                cancelTitle: 'Отмена',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(confirmed => {
                if (confirmed) {
                    this.toggleEarlyRepaymentFlag(row)
                }
            })
            .catch(error => {
                this.makeToast('Не удалось', 'Ошибка', 'danger')
                console.error(error.toString())
            })
    }

    async toggleEarlyRepaymentFlag(row: ScheduleRow) {
        const amount = row.isEarlyRepayment ? row.earlyRepayment : row.principalFact
        const newType = row.isEarlyRepayment ? ScheduleType.PRINCIPAL_REPAYMENT : ScheduleType.PAYMENT_REFUND

        const id = this.getAnyFactId(row)
        if (id == null) {
            this.makeToast('Отсутсвует идентификатор факта', 'Ошибка', 'danger')
            return
        }
        if (amount == null) {
            this.makeToast('Отсутсвует сумма факта', 'Ошибка', 'danger')
            return
        }

        const tempKbkOption: Option<string> | null = row.kbkCode ? {
            value: row.kbkCode,
            label: 'temp',
        } : null

        const form: PaymentForm = {
            id: id,
            paymentType: newType,
            amount: amount.toString(),
            date: this.toYYYYMMDDformat(row.paymentDate),
            kbk: tempKbkOption,
            note: row.note
        }

        this.paymentForm = form

        await this.saveOrUpdatePaymentForm()
    }

    async saveOrUpdatePaymentForm() {
        if (this.mainAgreement?.id == null) {
            this.makeToast('Не указан основной договор', 'Ошибка', 'danger')
            return
        }

        const paymentForm = cloneDeep(this.paymentForm)

        if (paymentForm.paymentType == null) {
            this.makeToast('Необходимо указать тип платежа', 'Ошибка', 'danger')
            return
        }
        if (paymentForm.date == null) {
            this.makeToast('Необходимо указать дату', 'Ошибка', 'danger')
            return
        }
        if (paymentForm.kbk?.value == null) {
            this.makeToast('Необходимо указать КБК', 'Ошибка', 'danger')
            return
        }

        const parsedAmount: number | null = paymentForm.amount == null ? null : parseSpacedDecimal(paymentForm.amount)
        const paymentType: ScheduleType = paymentForm.paymentType
        const formattedDate = paymentForm.date

        const request: FactRequest = {
            id: paymentForm.id,
            idContract: this.mainAgreement.id,
            typeSchedule: paymentType,
            sumPaymentFact: parsedAmount,
            dateFact: formattedDate,
            code: paymentForm.kbk.value,
            note: paymentForm.note,
            userName: this.userId,
            updateDate: null
        }

        const method = request.id != null ? 'PUT' : 'POST'
        const response = await fetch('api/budget-loan-schedule/payment-fact-inflow', {
            method: method,
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        })

        if (!response.ok) {
            let text = 'Извините, произошла ошибка на сервере или некорректно заполнены поля.'
            const errorResponse = await response.json()
            const message = errorResponse?.args[0]?.value[0]
            if (message) {
                text = message
            }
            this.makeToast(text, 'Ошибка сохранения', 'danger')
            return
        }

        this.makeToast('Сохранено', 'Сообщение', 'success')
        if (!this.showCommentModal) { // Показывать сообщение если не просто изменение комментария
            this.isForecastWarningMessageVisible = true
        }
        await this.reloadTable()
    }

    mergeRows(paramPlanRows: ScheduleRow[], paramForecastRows: ScheduleRow[], paramFactRows: ScheduleRow[]) {
        const planRows = cloneDeep(paramPlanRows)
        const forecastRows = cloneDeep(paramForecastRows)
        const factRows = cloneDeep(paramFactRows)

        const scheduleEntires = new Map<number, ScheduleRow>()

        // Set base schedule from forecast
        forecastRows.forEach(it => {
            // Для погашении ставить даты из плана
            const copy = cloneDeep(it)
            copy.principalPlan = null
            scheduleEntires.set(it.paymentDate, copy)
        })

        // Set plan inflows
        const inflowPlanRows = planRows
            .filter(it => it.inflowPlan)
            .sort((a, b) => a.paymentDate - b.paymentDate)

        inflowPlanRows.forEach(planRow => {
            const entry = scheduleEntires.get(planRow.paymentDate)
            if (!entry) {
                scheduleEntires.set(planRow.paymentDate, cloneDeep(planRow))
            } else {
                entry.inflowPlan = planRow.inflowPlan
                scheduleEntires.set(planRow.paymentDate, entry)
            }
        })

        // Явную досрочку отнимать с конца плана
        const principalPlanRows = planRows
            .filter(it => it.principalPlan)
            .sort((a, b) => a.paymentDate - b.paymentDate)
            
        let earlyRepaymentsSum = factRows
            .map(it => it.earlyRepayment ?? 0)
            .reduce((acc, curr) => acc + curr, 0)

        for (let i = principalPlanRows.length - 1; i >= 0; i--) {
            const planRow = principalPlanRows[i]

            const leftOver = earlyRepaymentsSum - (planRow.principalPlan ?? 0)
            if (leftOver <= 0) {
                planRow.principalPlan = Math.abs(leftOver)
                break
            } else {
                planRow.principalPlan = null
                earlyRepaymentsSum = leftOver
            }
        }

        for (const planRow of principalPlanRows) {
            const entry = scheduleEntires.get(planRow.paymentDate)
            if (!entry) {
                scheduleEntires.set(planRow.paymentDate, cloneDeep(planRow))
            } else {
                entry.principalPlan = planRow.principalPlan
                scheduleEntires.set(planRow.paymentDate, entry)
            }
        }

        const scheduleRows: ScheduleRow[] = [...scheduleEntires.values()]

        // Set fact
        for (const factRow of factRows) {
            const unsortedRows = scheduleRows.filter(it => it.paymentDate === factRow.paymentDate)
            const rows = unsortedRows.sort((a, b) => {
                const keys = ['inflowPlan', 'principalPlan', 'interestPlan', 'copaymentPlan'] as const
                for (const key of keys) {
                    if (a[key] && !b[key]) {
                        return -1 // aIsBefore
                    } else if (!a[key] && b[key]) {
                        return 1 // bIsBefore
                    } else if (a[key] && b[key]) {
                        return (a[key] ?? 0) - (b[key] ?? 0)
                    }
                }
                return 0
            })
            
            if (rows.isEmpty) {
                scheduleRows.push(cloneDeep(factRow))
                continue
            }

            const keys = ['inflow', 'principal', 'interest', 'copayment'] as const
            keys.forEach(key => {
                const factKey: 'inflowFact' | 'principalFact' | 'interestFact' | 'copaymentFact' = (`${key}Fact` as any)
                const planKey: 'inflowPlan' | 'principalPlan' | 'interestPlan' | 'copaymentPlan' = (`${key}Plan` as any)
                if (factRow[factKey]) {
                    const row = rows.find(it => it[planKey])
                    if (row) {
                        if (this.hasFact(row)) {
                            const copy = cloneDeep(factRow)
                            copy[planKey] = row[planKey]
                            row[planKey] = null
                            if (planKey === 'interestPlan') {
                                copy.daysCount = row.daysCount
                                copy.startDate = row.startDate
                                copy.endDate = row.endDate
                                copy.baseSum = row.baseSum
                                row.daysCount = null
                                row.startDate = null
                                row.endDate = null
                                row.baseSum = null
                            }
                            scheduleRows.push(copy)
                        } else {
                            const factDataKey: 'inflowFactData'
                            | 'principalFactData'
                            | 'earlyRepaymentData'
                            | 'unusedSumData'
                            | 'interestFactData'
                            | 'copaymentFactData' = (`${factKey}Data` as any)

                            row.kbkCode = factRow.kbkCode
                            row[factKey] = factRow[factKey]
                            row[factDataKey] = factRow[factDataKey]
                            row.isEarlyRepayment = factRow.isEarlyRepayment
                            row.note = factRow.note
                        }
                    } else {
                        scheduleRows.push(cloneDeep(factRow))
                    }
                }
            })
            if (factRow.earlyRepayment || factRow.unusedSum) {
                scheduleRows.push(cloneDeep(factRow))
            }
        }

        // Sorting
        const sortedRows = scheduleRows.sort((a, b) => {
            const aIsBefore = -1
            const bIsBefore = 1
            const isSame = 0

            // Sort by date
            if (a.paymentDate < b.paymentDate) {
                return aIsBefore
            } else if (a.paymentDate > b.paymentDate) {
                return bIsBefore
            }

            // If same date, sort by first-forecast, second-fact
            if (this.hasFact(a) && !this.hasFact(b)) {
                return bIsBefore
            } else if (!this.hasFact(a) && this.hasFact(b)) {
                return aIsBefore
            }

            // If both fact, sort by fact-type, then sum
            const keys = ['inflowFact', 'principalFact', 'earlyRepayment', 'unusedSum', 'interestFact', 'copaymentFact'] as const
            for (const key of keys) {
                if (a[key] && !b[key]) {
                    return aIsBefore
                } else if (!a[key] && b[key]) {
                    return bIsBefore
                } else if (a[key] && b[key]) {
                    return (a[key] ?? 0) - (b[key] ?? 0)
                }
            }

            return isSame
        })
        
        // Adding periodic interest consolidations
        const periodicInterestsMap = this.getPeriodicInterestsMap(forecastRows)

        const singleEntryConsolidationDates: Set<string> = new Set()
        periodicInterestsMap.forEach((sum, dateKey) => {
            const found = forecastRows.find(it => this.toYYYYMMDDformat(it.paymentDate) === dateKey)
            if (found && found.interestPlan === sum) {
                singleEntryConsolidationDates.add(dateKey)
            }
        })

        periodicInterestsMap.forEach((sum, date) => {
            if (singleEntryConsolidationDates.has(date)) {
                return
            }

            // @ts-ignore
            const index = sortedRows.findLastIndex(it => this.toYYYYMMDDformat(it.paymentDate) == date)
            if (index !== -1) {
                const newRow = cloneDeep(emptyScheduleRow)
                newRow.paymentDate = this.toDateMilliseconds(date)
                newRow.interestPlan = sum
                sortedRows.splice(index + 1, 0, newRow)
            }
        })

        // Cleaning of empty rows
        const nonEmptyRows = sortedRows.filter(it => (
            it.inflowPlan
            || it.inflowFact
            || it.principalPlan
            || it.principalFact
            || it.earlyRepayment
            || it.unusedSum
            || it.baseSum
            || it.interestPlan
            || it.interestFact
            || it.copaymentPlan
            || it.copaymentFact
            || it.copaymentFact
        ))

        // Numbering rows
        nonEmptyRows.forEach((it, index) => {
            it.rowNumber = index + 1
        })
        
        return nonEmptyRows
    }

    async getPlanRows(): Promise<ScheduleRow[]> {
        const planRows: ScheduleRow[] = []

        const planResponse = await fetch(`api/budget-loan-schedule/payment-schedule/${this.currentForm.id}`)
        if (!planResponse.ok) {
            this.makeToast("Не удалось загрузить плановые данные", "Ошибка", "danger")
            throw new Error('Не удалось загрузить плановые данные')
        }

        const planEntires: PlanEntry[] = await planResponse.json()

        planEntires.forEach(entry => {
            const newRow: ScheduleRow = {
                rowNumber: 0, // temporary, reset later
                leftPrincipal: null,
                paymentDate: this.toDateMilliseconds(entry.datePayment),
                kbkCode: null,
                inflowPlan: entry.typeSchedule === ScheduleType.INFLOW ? entry.sumPayment : null,
                inflowFact: null,
                principalPlan: entry.typeSchedule === ScheduleType.PRINCIPAL_REPAYMENT ? entry.sumPayment : null,   
                principalFact: null,
                earlyRepayment: null,
                unusedSum: null,
                startDate: entry.dateBeg,
                endDate: entry.dateEnd,
                daysCount: entry.dayCount,
                baseSum: entry.sumBase,
                interestPlan: entry.typeSchedule === ScheduleType.PAYMENT_INTEREST ? entry.sumPayment : null,
                interestFact: null,
                copaymentPlan: null,
                copaymentFact: null,
                isEarlyRepayment: null,
                note: null,
                // Additinal data properties
                inflowFactData: null,
                principalFactData: null,
                earlyRepaymentData: null,
                unusedSumData: null,
                interestFactData: null,
                copaymentFactData: null
            }
            planRows.push(newRow)
        })

        return planRows
    }

    async getFactRows(): Promise<ScheduleRow[]> {
        if (!this.mainAgreement) {
            this.makeToast("Не удалось загрузить фактические данные", "Ошибка", "danger")
            throw new Error('Не удалось загрузить фактические данные')
        }

        const factRows: ScheduleRow[] = []

        const factResponse = await fetch(`api/budget-loan-schedule/payment-fact-inflow/${this.mainAgreement.id}`)
        if (!factResponse.ok) {
            this.makeToast("Не удалось загрузить фактические данные", "Ошибка", "danger")
            throw new Error('Не удалось загрузить фактические данные')
        }
        const factEntries: FactEntry[] = await factResponse.json()

        factEntries.forEach(entry => {
            let isEarlyRepayment: boolean | null = null
            if (entry.typeSchedule === ScheduleType.PRINCIPAL_REPAYMENT) {
                isEarlyRepayment = false
            } else if (entry.typeSchedule === ScheduleType.PAYMENT_REFUND) {
                isEarlyRepayment = true
            }

            const newRow: ScheduleRow = {
                rowNumber: 0, // temporary, reset later
                leftPrincipal: null,
                paymentDate: this.toDateMilliseconds(entry.dateFact),
                kbkCode: entry.code,
                inflowPlan: null,
                inflowFact: entry.typeSchedule === ScheduleType.INFLOW ? entry.sumPaymentFact : null,
                principalPlan: null,   
                principalFact: entry.typeSchedule === ScheduleType.PRINCIPAL_REPAYMENT ? entry.sumPaymentFact : null,
                earlyRepayment: entry.typeSchedule === ScheduleType.PAYMENT_REFUND ? entry.sumPaymentFact : null,
                unusedSum: entry.typeSchedule === ScheduleType.PAYMENT_UNUSED ? entry.sumPaymentFact : null,
                startDate: null,
                endDate: null,
                daysCount: null,
                baseSum: null,
                interestPlan: null,
                interestFact: entry.typeSchedule === ScheduleType.PAYMENT_INTEREST ? entry.sumPaymentFact : null,
                copaymentPlan: null,
                copaymentFact: entry.typeSchedule === ScheduleType.PAYMENT_COPAYMENT ? entry.sumPaymentFact : null,
                isEarlyRepayment: isEarlyRepayment,
                note: entry.note || null,
                // Additinal data properties
                inflowFactData: entry.typeSchedule === ScheduleType.INFLOW ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                principalFactData: entry.typeSchedule === ScheduleType.PRINCIPAL_REPAYMENT ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                earlyRepaymentData: entry.typeSchedule === ScheduleType.PAYMENT_REFUND ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                unusedSumData: entry.typeSchedule === ScheduleType.PAYMENT_UNUSED ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                interestFactData: entry.typeSchedule === ScheduleType.PAYMENT_INTEREST ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                copaymentFactData: entry.typeSchedule === ScheduleType.PAYMENT_COPAYMENT ? { id: entry.id, sum: entry.sumPaymentFact } : null
            }
            factRows.push(newRow)
        })

        return factRows
    }

    async insertFactRows(forecastRows: ScheduleRow[]): Promise<ScheduleRow[]> {
        if (!this.mainAgreement) {
            this.makeToast("Не удалось загрузить фактические данные", "Ошибка", "danger")
            throw new Error('Не удалось загрузить фактические данные')
        }

        const tempScheduleRows = cloneDeep(forecastRows)

        const factResponse = await fetch(`api/budget-loan-schedule/payment-fact-inflow/${this.mainAgreement.id}`)
        if (!factResponse.ok) {
            this.makeToast("Не удалось загрузить фактические данные", "Ошибка", "danger")
            throw new Error('Не удалось загрузить фактические данные')
        }
        const factEntries: FactEntry[] = await factResponse.json()

        tempScheduleRows.forEach(row => {
            const onDateEntires = factEntries.filter(it => this.toDDMMYYYYformat(it.dateFact) === this.toDDMMYYYYformat(row.paymentDate))
            
            const inflowEntry = onDateEntires.find(it => it.typeSchedule === ScheduleType.INFLOW)
            if (inflowEntry) {
                row.inflowFact = inflowEntry.sumPaymentFact    
            }

            const principalEntry = onDateEntires.find(it => it.typeSchedule === ScheduleType.PRINCIPAL_REPAYMENT)
            if (principalEntry) {
                row.principalFact = principalEntry.sumPaymentFact
                row.isEarlyRepayment = false
            }

            const earlyRepaymentEntry = onDateEntires.find(it => it.typeSchedule === ScheduleType.PAYMENT_REFUND)
            if (earlyRepaymentEntry) {
                row.earlyRepayment = earlyRepaymentEntry.sumPaymentFact
                row.isEarlyRepayment = true
            }

            const unusedSumEntry = onDateEntires.find(it => it.typeSchedule === ScheduleType.PAYMENT_UNUSED)
            if (unusedSumEntry) {
                row.unusedSum = unusedSumEntry.sumPaymentFact
            }

            const interstEntry = onDateEntires.find(it => it.typeSchedule === ScheduleType.PAYMENT_INTEREST)
            if (interstEntry) {
                row.interestFact = interstEntry.sumPaymentFact
            }

            const copaymentEntry = onDateEntires.find(it => it.typeSchedule === ScheduleType.PAYMENT_COPAYMENT)
            if (copaymentEntry) {
                row.copaymentFact = copaymentEntry.sumPaymentFact
            }
        })

        factEntries.forEach(entry => {
            const existingRow = tempScheduleRows.find(it => this.toDDMMYYYYformat(it.paymentDate) === this.toDDMMYYYYformat(entry.dateFact))
            if (existingRow) {
                existingRow.kbkCode = entry.code
                existingRow.note = entry.note || null
                switch (entry.typeSchedule) {
                    case ScheduleType.INFLOW: {
                        existingRow.inflowFact = entry.sumPaymentFact
                        existingRow.inflowFactData = { id: entry.id, sum: entry.sumPaymentFact }  
                        break
                    }
                    case ScheduleType.PRINCIPAL_REPAYMENT: {
                        existingRow.principalFact = entry.sumPaymentFact  
                        existingRow.principalFactData = { id: entry.id, sum: entry.sumPaymentFact }  
                        break
                    }
                    case ScheduleType.PAYMENT_REFUND: {
                        existingRow.earlyRepayment = entry.sumPaymentFact  
                        existingRow.earlyRepaymentData = { id: entry.id, sum: entry.sumPaymentFact }  
                        break
                    }
                    case ScheduleType.PAYMENT_UNUSED: {
                        existingRow.unusedSum = entry.sumPaymentFact  
                        existingRow.unusedSumData = { id: entry.id, sum: entry.sumPaymentFact }  
                        break
                    }
                    case ScheduleType.PAYMENT_INTEREST: {
                        existingRow.interestFact = entry.sumPaymentFact  
                        existingRow.interestFactData = { id: entry.id, sum: entry.sumPaymentFact }  
                        break
                    }
                    case ScheduleType.PAYMENT_COPAYMENT: {
                        existingRow.copaymentFact = entry.sumPaymentFact
                        existingRow.copaymentFactData = { id: entry.id, sum: entry.sumPaymentFact }  
                        break
                    }
                    default:
                        break
                }
            } else {
                let isEarlyRepayment: boolean | null = null
                if (entry.typeSchedule === ScheduleType.PRINCIPAL_REPAYMENT) {
                    isEarlyRepayment = false
                } else if (entry.typeSchedule === ScheduleType.PAYMENT_REFUND) {
                    isEarlyRepayment = true
                }

                const newRow: ScheduleRow = {
                    rowNumber: 0,
                    leftPrincipal: null,
                    paymentDate: this.toDateMilliseconds(entry.dateFact),
                    kbkCode: entry.code,
                    inflowPlan: null,
                    inflowFact: entry.typeSchedule === ScheduleType.INFLOW ? entry.sumPaymentFact : null,
                    principalPlan: null,   
                    principalFact: entry.typeSchedule === ScheduleType.PRINCIPAL_REPAYMENT ? entry.sumPaymentFact : null,
                    earlyRepayment: entry.typeSchedule === ScheduleType.PAYMENT_REFUND ? entry.sumPaymentFact : null,
                    unusedSum: entry.typeSchedule === ScheduleType.PAYMENT_UNUSED ? entry.sumPaymentFact : null,
                    startDate: null,
                    endDate: null,
                    daysCount: null,
                    baseSum: null,
                    interestPlan: null,
                    interestFact: entry.typeSchedule === ScheduleType.PAYMENT_INTEREST ? entry.sumPaymentFact : null,
                    copaymentPlan: null,
                    copaymentFact: entry.typeSchedule === ScheduleType.PAYMENT_COPAYMENT ? entry.sumPaymentFact : null,
                    isEarlyRepayment: isEarlyRepayment,
                    note: entry.note || null,
                    // Additinal data properties
                    inflowFactData: entry.typeSchedule === ScheduleType.INFLOW ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                    principalFactData: entry.typeSchedule === ScheduleType.PRINCIPAL_REPAYMENT ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                    earlyRepaymentData: entry.typeSchedule === ScheduleType.PAYMENT_REFUND ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                    unusedSumData: entry.typeSchedule === ScheduleType.PAYMENT_UNUSED ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                    interestFactData: entry.typeSchedule === ScheduleType.PAYMENT_INTEREST ? { id: entry.id, sum: entry.sumPaymentFact } : null,
                    copaymentFactData: entry.typeSchedule === ScheduleType.PAYMENT_COPAYMENT ? { id: entry.id, sum: entry.sumPaymentFact } : null
                }
                tempScheduleRows.push(newRow)
            }
        })

        return tempScheduleRows
    }

    toDDMMYYYYformat(date: number | string | Date | null): string {
        if (date == null) {
            return ''
        }
        const formatted = moment(date).format('DD-MM-YYYY')
        return formatted
    }

    toYYYYMMDDformat(date: number | string | Date | Moment | null, initialFormat?: string): string {
        if (date == null) {
            return ''
        }
        const momentDate = initialFormat ? moment(date, initialFormat) : moment(date)
        const formatted = momentDate.format('YYYY-MM-DD') 
        return formatted
    }

    toDateMilliseconds(date: number | string | Date): number {
        if (date == null) {
            return 0
        }
        const milliseconds = moment(date).startOf('day').valueOf()
        return milliseconds
    }

    async getForecastRows(): Promise<ScheduleRow[]> {
        if (this.currentForm.followingInterestRepaymentMonth == null
            || this.currentForm.followingInterestRepaymentDay == null
            || this.currentForm.returnDate == null
            || this.currentForm.frequencyRate == null
        ) {
            return []
        }

        try {
            const response = await fetch(`/api/budget-loan-schedule/payment-schedule-forecast/get-data/${this.currentForm.id}`)
            const data: BudgetLoanForecastForm[] = await response.json()
            const forecastRows = this.mapBudgetLoanForecastFormToSchedule(data)
            return forecastRows
        } catch (error) {
            this.makeToast('Не удалось загрузить факт', 'Ошибка', 'danger')
            throw new Error('Не удалось загрузить факт')
        }
    }

    getPeriodicInterestsMap(data: ScheduleRow[]): Map<string, number> {
        if (!this.currentForm.followingInterestRepaymentDay || !this.currentForm.followingInterestRepaymentMonth) {
            return new Map()
        }

        const forecastInterestPayments = []

        const interestForecastItems = data.filter(it => it.interestPlan)

        const startDate = moment.max(
            moment(this.currentForm.disbursementStartDate),
            moment(this.currentForm.initialInterestRepaymentDate)
        )
        
        const formattedMonth = this.currentForm.followingInterestRepaymentMonth.toString().padStart(2, '0')
        const formattedDay = this.currentForm.followingInterestRepaymentDay.toString().padStart(2, '0')
        const followingStartDate = moment(`${startDate.year()}-${formattedMonth}-${formattedDay}`)
        
        if (followingStartDate.isBefore(startDate)) {
            followingStartDate.add(1, 'year')
        }

        const periodicInterestsMap: Map<string, number> = this.getPeriodicDates(
            followingStartDate,
            this.currentForm.returnDate!,
            this.currentForm.frequencyRate!,
        )
        // Начальная дата
        periodicInterestsMap.set(this.toYYYYMMDDformat(startDate), 0)             

        // Последняя дата (для вознаграждений вне периода)
        const tempSortedKeys = Array.from(periodicInterestsMap.keys()).sort((a, b) => {
            return this.toDateMilliseconds(a) - this.toDateMilliseconds(b) 
        })
        const lastPeriodDate = tempSortedKeys.pop()
        if (lastPeriodDate) {
            const afterEndPeriodInterestItems = interestForecastItems
                .filter(it => it.paymentDate > this.toDateMilliseconds(lastPeriodDate))
                .sort((a, b) => {
                    return a.paymentDate - b.paymentDate
                })

            const lastInterestItem = afterEndPeriodInterestItems.pop()
            if (lastInterestItem) {
                periodicInterestsMap.set(this.toYYYYMMDDformat(lastInterestItem.paymentDate), 0)
            }
        }
        
        const sortedKeys = Array.from(periodicInterestsMap.keys()).sort((a, b) => {
            return this.toDateMilliseconds(b) - this.toDateMilliseconds(a)
        }) // descending

        interestForecastItems.forEach(it => {
            const matchedKey = [...sortedKeys]
                .filter(key => this.toDateMilliseconds(key) >= this.toDateMilliseconds(it.paymentDate))
                .pop()

            if (matchedKey) {
                const accumulatedSum = periodicInterestsMap.get(matchedKey)
                const newSum = (accumulatedSum??0) + (it.interestPlan??0)
                periodicInterestsMap.set(matchedKey, newSum)
            }
        })

        periodicInterestsMap.forEach((totalSum, strDate) => {
            if (totalSum) {
                forecastInterestPayments.push({ datePayment: this.toDateMilliseconds(strDate), interestSum: totalSum })
            }
        })

        return periodicInterestsMap
    }

    mapBudgetLoanForecastFormToSchedule(data: BudgetLoanForecastForm[]) {
        return data
            .filter(it => it.sumInflow
                || it.sumPrincipalRepaymentForecast
                || it.sumInterestForecast
                || it.sumPenaltyPrincipal
                || it.sumPenaltyInterest)
            .sort((a, b) => a.scheduleDate - b.scheduleDate)
            .map(it => {
                const copaymentSum = (it.sumPenaltyPrincipal??0) + (it.sumPenaltyInterest??0)

                const row: ScheduleRow = {
                    rowNumber: 0, 
                    leftPrincipal: it.principalBalance,
                    paymentDate: this.toDateMilliseconds(it.scheduleDate),
                    kbkCode: null,
                    inflowPlan: it.sumInflow,
                    inflowFact: null,
                    principalPlan: it.sumPrincipalRepaymentForecast,   
                    principalFact: null,
                    earlyRepayment: null,
                    unusedSum: null,
                    startDate: it.dateBeg,
                    endDate: it.dateEnd,
                    daysCount: it.dayCount,
                    baseSum: it.sumBase,
                    interestPlan: it.sumInterestForecast,
                    interestFact: null,
                    copaymentPlan: copaymentSum,
                    copaymentFact: null,
                    isEarlyRepayment: null,
                    note: null,
                    // Additinal data properties
                    inflowFactData: null,
                    principalFactData: null,
                    earlyRepaymentData: null,
                    unusedSumData: null,
                    interestFactData: null,
                    copaymentFactData: null
                }

                return row
            })
    }

    async getAgreement(id: number): Promise<Agreement> {
        const response = await fetch(`/api/budget-loan/${id}`)
        if (!response.ok) {
            this.makeToast('Не удалось загрузить договор (план)', 'Сообщение', 'danger')
            throw new Error('')
        }
        const agreement: Agreement = await response.json()
        return agreement
    }

    async getAgreements(id: number): Promise<Agreement[]> {
        const response = await fetch(`/api/budget-loan/${id}/with-additionals`)
        if (!response.ok) {
            this.makeToast('Не удалось загрузить договора (план)', 'Сообщение', 'danger')
            throw new Error('')
        }

        const agreements: Agreement[] = await response.json()
        return agreements
    }

    assignHeaderData() {
        if (this.currentAgreement?.id === this.mainAgreement?.id) {
            this.headerData = {
                mainNumberContract: this.mainAgreement?.agreementNumber ?? null,
                actualNumberContract: null,
                actualAmount: this.mainAgreement?.amount ?? null,
                actualContractor: this.mainAgreementForm?.contractor?.label ?? null
            }
        } else {
            this.headerData = {
                mainNumberContract: this.mainAgreement?.agreementNumber ?? null,
                actualNumberContract: this.currentAgreement?.agreementNumber ?? null,
                actualAmount: this.currentAgreement?.amount ?? null,
                actualContractor: this.actualAgreementForm?.contractor?.label ?? null
            }
        }
    }

    makeToast(message: string, title: string, variant: 'success' | 'danger') {
        this.$bvToast.toast(message, {
            title: title,
            variant: variant,
            solid: true,
        })
    }

    hasFact(row: ScheduleRow): boolean {
        return Boolean(row.inflowFact)
            || Boolean(row.earlyRepayment)
            || Boolean(row.unusedSum)
            || Boolean(row.principalFact)
            || Boolean(row.interestFact)
            || Boolean(row.copaymentFact)
    }

    hasPlan(row: ScheduleRow): boolean {
        return Boolean(row.inflowPlan)
            || Boolean(row.principalPlan)
            || Boolean(row.interestPlan)
            || Boolean(row.copaymentPlan)
    }
    // #endregion

    // #region Import declarations
    formatNumber = formatNumber
    // #endregion
}
